/* eslint-disable eqeqeq */
/* eslint-disable no-plusplus */
/* eslint-disable array-callback-return */
/* eslint-disable no-undef */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useToasts } from 'react-toast-notifications';
import Cookies from 'js-cookie';
import { LocaleContext, ConfigsContext, AppContext } from './configs';
import {
  getLocale,
  setLocale as persistLocale,
  getAccountBalance,
  getUserId,
  getLoginDetails,
  getBalance,
} from './client/client';
import CallbackRequest from './app/components/Callback';
import { useReactPath } from './util';

// declarations
const defaultLocale = getLocale() || 'en';

export const LocaleProvider = ({ children }) => {
  const [locale, setLocaleState] = useState(defaultLocale);

  return (
    <LocaleContext.Provider
      value={{
        locale,
        changeLocale: (newLocale) => {
          setLocaleState(newLocale);
          persistLocale(newLocale);
        },
      }}
    >
      {children}
    </LocaleContext.Provider>
  );
};

export const ConfigProvider = ({ children, app, emgUser, authorized }) => {
  const { path, defaults } = useReactPath();
  const { addToast } = useToasts();
  const [credits, setCredits] = useState(0);
  const [isLoading, setLoading] = useState(false);
  const [shouldReload, setShouldReload] = useState(0);
  const [balances, setBalances] = useState({
    airtime: '0.00',
    bpay: '0.00',
    ussd: '0.00',
    sms: '0.00',
    loading: false,
  });
  useEffect(() => {
    let cancelled = false;

    const run = async () => {
      if (!authorized) return;

      setLoading(true);
      setBalances((prev) => ({
        ...prev,
        loading: true,
      }));

      let currentPath = path;

      if (path === 'authentication' || defaults === 'authentication') {
        const hashPath = window.location.hash;
        const segments = hashPath.split('/');
        currentPath = segments[segments.length - 1];
      }

      try {
        if (path === 'rewards') {
          const apps = ['AIRTIME', 'BPAY', 'USSD'];

          const results = await Promise.allSettled(
            apps.map((app_name) =>
              getBalance({ user_id: getUserId(), app_name }).then(
                (res) => res?.data?.credit_bal || '0.0000'
              )
            )
          );

          const [airtime, bpay, ussd] = results.map((r) =>
            r.status === 'fulfilled' ? r.value : '0.0000'
          );

          let smsResponse = await getAccountBalance(
            { vendor_id: getUserId() },
            'sms',
            'EMG',
            emgUser,
            defaults
          );
          if (smsResponse.data === false) {
            smsResponse = await getAccountBalance(
              { vendor_id: getUserId() },
              'sms',
              'SMS',
              emgUser,
              defaults
            );
          }

          const sms =
            smsResponse.data.credit_balance ??
            smsResponse.data.credit_bal ??
            '0.0000';

          if (!cancelled) {
            setBalances({ sms, airtime, bpay, ussd, loading: false });
            setLoading(false);
          }
          return;
        }

        const response = await getAccountBalance(
          { vendor_id: getUserId() },
          path,
          app,
          emgUser,
          defaults,
          currentPath
        );

        if (!cancelled) {
          setCredits(
            response.data.credit_balance ?? response.data.credit_bal ?? 0
          );
          setLoading(false);
        }
      } catch (error) {
        if (!cancelled) {
          setLoading(false);
          setBalances((prev) => ({ ...prev, loading: false }));
          if (!error.isNetworkError) {
            addToast(error.message, { appearance: 'error' });
          }
        }
      }
    };

    run();
    return () => {
      cancelled = true;
    };
  }, [addToast, shouldReload, path, defaults, emgUser, authorized]);

  return (
    <ConfigsContext.Provider
      value={{
        credits,
        isLoading,
        refreshBalance: () => setShouldReload(shouldReload + 1),
        path,
        defaults,
        balances,
      }}
    >
      {children}
    </ConfigsContext.Provider>
  );
};

export const AppProvider = ({ path, defaults, authorized, children }) => {
  const login_attempts = getLoginDetails();
  const [attempts, setAttempts] = useState(login_attempts);
  const [error, setError] = useState(false);
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    if (authorized) {
      setLoading(false);
      setError(false);
      if (login_attempts) {
        login_attempts.map((el) => {
          if (path && path === el.app_name.toLowerCase() && el.attempts < 1) {
            setLoading(true);
            setError(false);
            CallbackRequest({ app_name: el.app_name })
              .then(() => {
                const objIndex = login_attempts.findIndex(
                  (obj) => obj.app_name.toLowerCase() === path
                );
                login_attempts[objIndex].attempts++;
                Cookies.set('attempts', login_attempts);
                setLoading(false);
                setAttempts(login_attempts);
                setError(false);
              })
              .catch(() => {
                setLoading(false);
                setError(true);
              });
          }
        });
      }
    }
  }, [path]);

  return (
    <AppContext.Provider value={{ error, path, defaults, attempts, isLoading }}>
      {children}
    </AppContext.Provider>
  );
};

ConfigProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
